export enum TabNames {
  Attività = 'Attività',
  Dettagli = 'Dettagli',
  Condominio = 'Condominio',
  Inoltro = 'Inoltro'
}
